import React from 'react'
import HomeIcon from '@material-ui/icons/Home'
import AndroidOutlinedIcon from '@material-ui/icons/AndroidOutlined'
import VpnLockOutlinedIcon from '@material-ui/icons/VpnLockOutlined'
import BackupOutlinedIcon from '@material-ui/icons/BackupOutlined'
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import QueuePlayNextIcon from '@material-ui/icons/QueuePlayNext';
import DateRangeIcon from '@material-ui/icons/DateRange';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';

export const SidebarData = [
    {
        title: 'Home',
        icon: <HomeIcon />,
        link: '/Main',
    },
    {
        title: 'WhatsBot',
        icon: <AndroidOutlinedIcon />,
        link: '/WhatsBot',
    },

    {
        title: 'Chamados',
        icon: <FormatListBulletedIcon />,
        link: '/Chamados',
    },
    {
        title: 'Backups',
        icon: <BackupOutlinedIcon />,
        link: '/Backups',
    },
    {
        title: 'Reports Semanais',
        icon: <DateRangeIcon />,
        link: '/reportsemanal/empresas',
    },
    {
        title: 'Reports Semanais (Todos)',
        icon: <CalendarTodayIcon />,
        link: '/reportsemanal/all',
    },
    {
        title: 'Cadastrar empresas',
        icon: <QueuePlayNextIcon />,
        link: '/cad/empresas',
    },
    {
        title: 'Monitoramento',
        icon: <VpnLockOutlinedIcon />,
        link: '/Mon',
    },
]
